module.exports = __webpack_public_path__ + "img/newdataset_od.8b208915.png";